import { createSelector } from "@ngxs/store";
import { IORD_Order } from "../../interfaces/request.interface";

/**
 * Cross-state selectors that depend on both RequestState and OptionState.
 *
 * These use createSelector with deferred initialization so that the state
 * classes are resolved at first use (runtime) rather than at module evaluation
 * time. This avoids the "Cannot read properties of undefined" error that
 * occurs in production builds due to import-ordering issues.
 */

function lazySelectors() {
    // These requires are inside a function body, so they execute only when
    // the function is called — well after every module has finished loading.
    const { RequestState } = require("./request.state");
    const { OptionState } = require("./options.state");
    return { RequestState, OptionState };
}

let _getfilteredUppersections: any;
let _activeProductLine: any;
let _activeSubPSL: any;

export class CombinedSelectors {

    static get getfilteredUppersections() {
        if (!_getfilteredUppersections) {
            const { RequestState, OptionState } = lazySelectors();
            _getfilteredUppersections = createSelector(
                [RequestState.getRequest, OptionState.uppersection],
                (request: IORD_Order | undefined, uppersections: any[]) => {
                    if (!request) {
                        return [];
                    }
                    return (
                        uppersections.filter((p: any) =>
                            p['BitMin'] <= (request?.bit?.size ?? 0) &&
                            p['BitMax'] >= (request?.bit?.size ?? 0)
                        ) ?? []
                    );
                }
            );
        }
        return _getfilteredUppersections;
    }

    static get activeProductLine() {
        if (!_activeProductLine) {
            const { RequestState, OptionState } = lazySelectors();
            _activeProductLine = createSelector(
                [RequestState.getRequest, OptionState.productlines],
                (request: IORD_Order | undefined, productLines: { value: number; name: string; subcategory?: string }[]): string => {
                    if (!request) {
                        return 'NA';
                    }
                    return (
                        productLines.find(pl => pl.value === request.productLine)?.name
                        ?? 'NA'
                    );
                }
            );
        }
        return _activeProductLine;
    }

    static get activeSubPSL() {
        if (!_activeSubPSL) {
            const { RequestState, OptionState } = lazySelectors();
            _activeSubPSL = createSelector(
                [RequestState.getRequest, OptionState.productlines],
                (request: IORD_Order | undefined, productLines: { value: number; name: string; subcategory?: string }[]): string => {
                    if (!request) {
                        return 'NA';
                    }
                    return (
                        productLines.find(pl => pl.value === request.productLine)?.subcategory
                        ?? 'NA'
                    );
                }
            );
        }
        return _activeSubPSL;
    }
}
